import applyLicense from './applyLicense';
applyLicense();
export { default as applyLicense } from './applyLicense';
export * from '@ori-ui/mui-bundle/x-license-pro';
//# sourceMappingURL=index.js.map